import { TransactionSuccessToast, ToastDetailRow } from "@/components";
import { TOKEN_IDS, type TransactionHash } from "@/types";

interface WithdrawLockSuccessToastProps {
    withdrawAmount: number;
    lockDuration: number;
    transactionHash: TransactionHash;
    onClose?: () => void;
}

export function WithdrawLockSuccessToast({
    withdrawAmount,
    lockDuration,
    transactionHash,
    onClose,
}: WithdrawLockSuccessToastProps) {
    return (
        <TransactionSuccessToast title="Withdrawal started" transactionHash={transactionHash} onClose={onClose}>
            <ToastDetailRow label="Withdrawing" amount={withdrawAmount} tokenId={TOKEN_IDS.IUSD} />
            <div className="flex justify-between items-center">
                <div className="text-gray-400">Duration</div>
                <div className="text-white">{lockDuration} weeks</div>
            </div>
        </TransactionSuccessToast>
    );
}
